import { CardSkeleton, DashCard } from "../DashboardCards";
import {Avatar, Box, Typography} from "@mui/material";
import { COLORS } from "../../configs/config";
import {grey} from "@mui/material/colors";
import {getCategoryIconByName} from "../../../../../../configs/functions";
import {useState} from "react";

export const ProductRankingCard = ({ data, loading }) => {
    const [imgError, setImgError] = useState(false);

    if (loading) return <CardSkeleton height={200} />;

    const items = data ?? [];

    return (
        <DashCard title="Ranking de produtos consumidos" tag={`top ${items.length}`}>
            <Box display="flex" flexDirection="column">
                {items.map((item, i) => (
                    <Box
                        key={item.idProduto}
                        display="flex"
                        alignItems="center"
                        gap={1.25}
                        sx={{
                            py: 1,
                            borderBottom: i < items.length - 1 ? `0.5px solid ${COLORS.border}` : "none",
                        }}
                    >
                        <Typography variant="caption" sx={{
                            color: COLORS.tDim, width: 14,
                            textAlign: "center", flexShrink: 0,
                        }}>
                            {i + 1}
                        </Typography>

                        <Avatar
                            sx={{
                                bgcolor: grey[100], color: grey[600], maxWidth: 38, maxHeight: 38
                            }}
                            onDragStart={(e) => e.preventDefault()}
                        >
                            {getCategoryIconByName(item.url)}
                        </Avatar>

                        <Box flex={1} minWidth={0}>
                            <Typography variant="caption" sx={{
                                color: COLORS.tSec, fontWeight: 600,
                                display: "block",
                                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                            }}>
                                {item.nome}
                            </Typography>

                            <Typography variant="caption" sx={{ color: COLORS.tDim }}>
                                CA {item.ca}
                            </Typography>
                        </Box>
                    </Box>
                ))}
                {items.length === 0 && (
                    <Typography variant="caption" sx={{ color: COLORS.tDim }}>
                        Nenhum dado disponível
                    </Typography>
                )}
            </Box>
        </DashCard>
    );
};